import {
  FETCH_START,
  FETCH_END,
  FORECAST_LEVEL_DATA_SUCCESS,
  FORECAST_LEVEL_BY_ID,
  FORECAST_LEVEL_DROPDWON_SUCCESS,
  SALES_FORECAST_FORMAT_LIST_SUCCESS,
  DYNAMIC_QUERY_SALES_FORECAST_DETAILS_SUCCESS,
  SALES_FORECAST_QUERY_SINGLE_SUCCESS,
  SALES_FORECAST_QUERY_FIELDS_SUCCESS,
  DYNAMIC_QUERY_FORECAST_FIELDS_SUCCESS,
  SALES_FORECAST_UPLOAD_SUCCESS,
  SALES_FORECAST_DATA_SUCCESS,
  GET_FORECASTS_START,
  GET_FORECASTS_SUCCESS,
  GET_FORECASTS_FAIL,
  GET_FORECAST_BY_ID_START,
  GET_FORECAST_BY_ID_SUCCESS,
  GET_FORECAST_BY_ID_FAIL,
  CREATE_FORECAST_START,
  CREATE_FORECAST_SUCCESS,
  CREATE_FORECAST_FAIL,
  UPDATE_FORECAST_START,
  UPDATE_FORECAST_SUCCESS,
  UPDATE_FORECAST_FAIL,
  DELETE_FORECAST_START,
  DELETE_FORECAST_SUCCESS,
  DELETE_FORECAST_FAIL,
  GET_FORECAST_DATA_START,
  GET_FORECAST_DATA_SUCCESS,
  GET_FORECAST_DATA_FAIL,
  SAVE_FORECAST_DATA_START,
  SAVE_FORECAST_DATA_SUCCESS,
  SAVE_FORECAST_DATA_FAIL,
  EXECUTE_QUERY_START,
  EXECUTE_QUERY_SUCCESS,
  EXECUTE_QUERY_FAIL,
  UPLOAD_FORECAST_DATA_START,
  UPLOAD_FORECAST_DATA_SUCCESS,
  UPLOAD_FORECAST_DATA_FAIL,
  COPY_FORECAST_DATA_START,
  COPY_FORECAST_DATA_SUCCESS,
  COPY_FORECAST_DATA_FAIL,
  EXTERNAL_LOGIN_START,
  EXTERNAL_LOGIN_SUCCESS,
  EXTERNAL_LOGIN_FAIL,
  GET_EXTERNAL_ATTRIBUTES_START,
  GET_EXTERNAL_ATTRIBUTES_SUCCESS,
  GET_EXTERNAL_ATTRIBUTES_FAIL,
  GET_EXTERNAL_QUERIES_START,
  GET_EXTERNAL_QUERIES_SUCCESS,
  GET_EXTERNAL_QUERIES_FAIL,
  GET_FORECAST_ATTRIBUTE_LABELS_START,
  GET_FORECAST_ATTRIBUTE_LABELS_SUCCESS,
  GET_FORECAST_ATTRIBUTE_LABELS_FAIL,
  RUN_SQL_WORKBENCH_START,
  RUN_SQL_WORKBENCH_SUCCESS,
  RUN_SQL_WORKBENCH_FAIL,
  BUDGET_FORECAST_FORMAT_LIST_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { history } from '../../../components/Helpers';
import { toast } from 'react-toastify';
import { ServerError } from '../../../library/constants/constants';
import secureLocalStorage from 'react-secure-storage';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};

// Historical Sales Upload
export const uploadHistoricalSalesFile = (file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadHistoricalSalesFileApi(file)
      .then((response) => {
        if (response.status === 200) {
          //window.location.reload();
          dispatch(fetchEnd());
          toast.success('File has been successfully uploaded.');
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadHistoricalSalesFileApi = (file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-sales-history', file, { headers: headers });
  return result;
};
//  get Forecast Level
export const getAllForecastLevelData = () => {
  return (dispatch) => {
    getAllForecastLevelDataApi().then((response) => {
      dispatch(getAllForecastLevelDataSuccess(response.data.response));
    });
  };
};

const getAllForecastLevelDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('sales-forecast-level-all?page=1&&limit=0', {
    headers: headers,
  });
  return result;
};

export const getAllForecastLevelDataSuccess = (data) => {
  return {
    type: FORECAST_LEVEL_DATA_SUCCESS,
    data,
  };
};
export const createForecastLevel = (data, id, type) => {
  return (dispatch) => {
    createForecastLevelAPI(data, id, type)
      .then((response) => {
        history.push('/forecasting-config');
        dispatch(getAllForecastLevelData());
        toast.success(response.data.response);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error);
      });
  };
};

const createForecastLevelAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('sales-forecast-level/' + id, data, {
      headers: headers,
    });
  } else if (type === 'delete') {
    result = axios.delete('sales-forecast-level/' + id, { headers: headers });
  } else {
    result = axios.post('sales-forecast-level', data, { headers: headers });
  }
  return result;
};
export const getForecastLevelById = (id) => {
  return (dispatch) => {
    getForecastLevelByIdAPI(id)
      .then((response) => {
        dispatch(getForecastLevelByIdSuccess(response.data.response));
        history.push('/forecasting-config/edit-config/' + id);
      })
      .catch((error) => { });
  };
};

export const viewForecastLevelById = (id) => {
  return (dispatch) => {
    getForecastLevelByIdAPI(id)
      .then((response) => {
        dispatch(getForecastLevelByIdSuccess(response.data.response));
        history.push('/forecasting-config/view-config/' + id);
      })
      .catch((error) => { });
  };
};

const getForecastLevelByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('sales-forecast-level?id=' + id, { headers: headers });
  return result;
};

export const getForecastLevelByIdSuccess = (data) => {
  return {
    type: FORECAST_LEVEL_BY_ID,
    data,
  };
};

//  get forecast config drop down value
export const getAllForecastLevelDropDwon = () => {
  return (dispatch) => {
    getAllForecastLevelDropDwonApi().then((response) => {
      dispatch(getAllForecastLevelDropDwonSuccess(response.data.response));
    });
  };
};

const getAllForecastLevelDropDwonApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('sales-forecast-fields', { headers: headers });
  return result;
};

export const getAllForecastLevelDropDwonSuccess = (data) => {
  return {
    type: FORECAST_LEVEL_DROPDWON_SUCCESS,
    data,
  };
};

//predict sales
export const predictSales = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    predictSalesAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        history.push('/forecasting-sales');
        toast.success('Forecasting is saved.');
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const predictSalesAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('predict-sales', data, { headers: headers });
  return result;
};
export const buildForecast = (data, type, item) => {
  return (dispatch) => {
    dispatch(fetchStart());
    buildForecastAPI(data, type, item)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //dispatch(calculationSimulationFailed(error));
        //toast.error(error.response.data.complete_error_message)
      });
  };
};
const buildForecastAPI = (data, type, item) => {
  for (var propName in data['filters']) {
    if (
      data['filters'][propName] === '' ||
      data['filters'][propName] === null ||
      data['filters'][propName] === undefined ||
      data['filters'][propName].length === 0 ||
      data['filters'][propName] ===
      '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data['filters'][propName] === '1970-01-01T00:00:00.000Z' ||
      data['filters'][propName] === ','
    ) {
      delete data['filters'][propName];
    }
  }
  if (
    data['filters']['billing_date'][0].length == 0 ||
    data['filters']['billing_date'][1].length == 0
  ) {
    delete data['filters']['billing_date'];
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('copy-sales-to-forecast', data, { headers: headers });
  return result;
};
// getSalesForecastFormatList -- get all format lists
export const getSalesForecastFormatList = () => {
  return (dispatch) => {
    getSalesForecastFormatListAPI()
      .then((response) => {
        dispatch(getSalesForecastFormatListSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error('Error');
      });
  };
};

const getSalesForecastFormatListAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=SalesForecastDataFormat',
    { headers: headers },
  );
  return result;
};

export const getSalesForecastFormatListSuccess = (data) => {
  return {
    type: SALES_FORECAST_FORMAT_LIST_SUCCESS,
    data,
  };
};

//get dynamic query for sales forecast--- view query
export const getDynamicQuerySalesForecast = (id) => {
  return (dispatch) => {
    getDynamicQuerySalesForecastAPI(id).then((response) => {
      dispatch(getDynamicQuerySalesForecastSuccess(response.data.response));
      // if (response.data && response.data.response && response.data.response.table_name &&
      //     response.data.response.table_name === 'sales_data') {
      //     dispatch(getDynamicQuerySalesDataFields());
      // } else if (response.data && response.data.response && response.data.response.table_name &&
      //     response.data.response.table_name === 'financial_postings') {
      //     dispatch(getDynamicQueryFields());
      // }
      // else if (response.data && response.data.response && response.data.response.table_name &&
      //     response.data.response.table_name === 'purchase_data') {
      //     dispatch(getPurchaseDataFields());
      // } else {
      //     dispatch(getCalculationSimulationDataFields());
      // }
    });
  };
};

const getDynamicQuerySalesForecastAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('sales-forecast-data-format?format_id=' + id, {
    headers: headers,
  });
  return result;
};
export const getDynamicQuerySalesForecastSuccess = (data) => {
  return {
    type: DYNAMIC_QUERY_SALES_FORECAST_DETAILS_SUCCESS,
    data,
  };
};
// for sales forecast viewformat
export const getDynamicQueryForecastFields = () => {
  return (dispatch) => {
    getDynamicQueryForecastFieldsAPI().then((response) => {
      dispatch(getDynamicQueryForecastFieldsSuccess(response.data.response));
    });
  };
};

const getDynamicQueryForecastFieldsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('financial-posting-fields', { headers: headers });
  return result;
};

export const getDynamicQueryForecastFieldsSuccess = (data) => {
  sessionStorage.setItem('dq_table_name', data.table_name);
  return {
    type: DYNAMIC_QUERY_FORECAST_FIELDS_SUCCESS,
    data,
  };
};

export const fetchSalesForecastQuerySingle = (id) => {
  return (dispatch) => {
    fetchSalesForecastQuerySingleAPI(id)
      .then((response) => {
        dispatch(fetchSalesforecastQuerySingleSuccess(response.data.response));
        history.push('/historical-sales-upload/edit-format/' + id);
      })
      .catch((error) => {
        //toast.error('Error');
      });
  };
};

const fetchSalesForecastQuerySingleAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format/' + id + '?app-functionality=SalesForecastDataFormat',
    { headers: headers },
  );
  return result;
};

export const fetchSalesforecastQuerySingleSuccess = (data) => {
  return {
    type: SALES_FORECAST_QUERY_SINGLE_SUCCESS,
    data,
  };
};

//upload new sales data
export const salesForecastDataUploadNew = (file, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    salesForecastDataUploadNewAPI(file, id, type)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadSalesForecastFileSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.success_msg
          ) {
            toast.success(response.data.response.success_msg);
          }
          if (response.data.response?.warning_msg)
            toast.warning('We have some warnings, please check Data log.')
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //if (error.response && error.response.data && error.response.data.complete_error_message)
        //toast.error(error.response.data.complete_error_message)
      });
  };
};

//update sales forecast format
export const updateSalesForecastFormatQuery = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateSalesForecastFormatQueryApi(id, data, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201) {
          toast.success(response.data.response);
          if (type == 'SalesForecastupload') {
            history.push('/sales-forecast-upload');
          } else {
            history.push('/historical-sales-upload');
          }
        } else {
          //toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const updateSalesForecastFormatQueryApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'upload-format/' + id + '?app-functionality=SalesForecastDataFormat',
    data,
    { headers: headers },
  );
  return result;
};

const salesForecastDataUploadNewAPI = (file, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  if (type == 'Sales')
    result = axios.post('upload-file?format_id=' + id, file, {
      headers: headers,
    });
  else if (type == 'Budget')
    result = axios.post('upload-file?format_id=' + id + '&app-functionality=PromotionBudgetSalesForecastDataFormat', file, {
      headers: headers,
    });
  else
    result = axios.post('sales-forecast-data-upload?format_id=' + id, file, {
      headers: headers,
    });

  // var result; = axios.post("sales-forecast-data-upload?format_id=" + id, file, {
  //   headers: headers,

  return result;
};
export const uploadSalesForecastFileSuccess = (data) => {
  return {
    type: SALES_FORECAST_UPLOAD_SUCCESS,
    data,
  };
};

//load default forecast fields -- get all fields
export const loadSalesForecastDataFormatFields = () => {
  return (dispatch) => {
    loadSalesForecastDataFormatFieldsAPI()
      .then((response) => {
        dispatch(
          loadSalesForecastDataFormatFieldsSuccess(response.data.response),
        );
      })
      .catch((error) => {
        //toast.error('Error');
      });
  };
};
// delete sales forecast format
export const deleteSalesForecastDataQuery = (id, page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteSalesForecastDataQueryApi(id, page)
      .then((response) => {
        if (page == 'salesForecastUpload')
          history.push('/sales-forecast-upload');
        else history.push('/historical-sales-upload');
        toast.success(response.data.response);
        dispatch(getSalesForecastFormatList());
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const deleteSalesForecastDataQueryApi = (id, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

const loadSalesForecastDataFormatFieldsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=SalesForecastDataFormat',
    { headers: headers },
  );
  return result;
};

export const loadSalesForecastDataFormatFieldsSuccess = (data) => {
  return {
    type: SALES_FORECAST_QUERY_FIELDS_SUCCESS,
    data,
  };
};

// post Sales forecast Data Query
export const postSalesForecastDataQuery = (data, type) => {
  return (dispatch) => {
    postSalesForecastDataQueryAPI(data).then((response) => {
      if (type == 'SalesForecastupload') {
        history.push('/sales-forecast-upload');
      } else {
        history.push('/historical-sales-upload');
      }
    });
  };
};

const postSalesForecastDataQueryAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    'upload-format?app-functionality=SalesForecastDataFormat',
    data,
    { headers: headers },
  );
  return result;
};

// Budget Forecast Format List Functions
export const getBudgetForecastFormatList = () => {
  return (dispatch) => {
    getBudgetForecastFormatListAPI()
      .then((response) => {
        dispatch(getBudgetForecastFormatListSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error('Error');
      });
  };
};

const getBudgetForecastFormatListAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionBudgetSalesForecastDataFormat',
    { headers: headers },
  );
  return result;
};
export const getBudgetForecastFormatListSuccess = (data) => {
  return {
    type: BUDGET_FORECAST_FORMAT_LIST_SUCCESS,
    data,
  };
};

// Post Budget Sales Forecast Data
export const postBudgetSalesForecast = (data, type) => {
  return (dispatch) => {
    postBudgetSalesForecastAPI(data)
      .then((response) => {
        toast.success(response.data.response);
        if (type == 'BudgetForecastupload') {
          history.push('/budget-forecast-upload');
        } else {
          history.push('/budget-forecast-upload');
        }
      })
      .catch((error) => {
        // Handle error if needed
        console.error('Error posting budget sales forecast:', error);
      });
  };
};

const postBudgetSalesForecastAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('upload-format?app-functionality=PromotionBudgetSalesForecastDataFormat', data, {
    headers: headers,
  });
  return result;
};

// Update Budget Forecast Format Query
export const updateBudgetForecastFormatQuery = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateBudgetForecastFormatQueryApi(id, data, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201) {
          toast.success(response.data.response);
          if (type == 'BudgetForecastupload') {
            history.push('/budget-forecast-upload');
          } else {
            history.push('/budget-forecast-upload');
          }
        } else {
          //toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const updateBudgetForecastFormatQueryApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'upload-format/' + id + '?app-functionality=PromotionBudgetSalesForecastDataFormat',
    data,
    { headers: headers },
  );
  return result;
};
export const getBudgetForcastFormatFields = () => {
  return (dispatch) => {
    getBudgetForcastFormatFieldsAPI()
      .then((response) => {
        dispatch(getBudgetForecastFormatListSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error('Error');
      });
  };
};

const getBudgetForcastFormatFieldsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionBudgetSalesForecastDataFormat',
    { headers: headers },
  );
  return result;
};

// Delete Budget Forecast Format Query
export const deleteBudgetForecastDataQuery = (id, page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteBudgetForecastDataQueryApi(id, page)
      .then((response) => {
        dispatch(fetchEnd());
        if (page == 'budgetForecastUpload') {
          history.push('/budget-forecast-upload');
        }
        toast.success(response.data.response);
        dispatch(getBudgetForcastFormatFields());
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const deleteBudgetForecastDataQueryApi = (id, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

export const getSalesForecastMainData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getSalesForecastMainDataApi().then((response) => {
      dispatch(fetchEnd());
      dispatch(getSalesForecastMainDataSuccess(response.data.response));
    });
  };
};

const getSalesForecastMainDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('sales-forecast-data?page=1&limit=0', {
    headers: headers,
  });
  return result;
};

export const getSalesForecastMainDataSuccess = (data) => {
  return {
    type: SALES_FORECAST_DATA_SUCCESS,
    data,
  };
};

export const uploadSalesForecastFile = (file, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadSalesForecastFileApi(file, data)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadSalesForecastFileSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.success_msg
          ) {
            toast.success(response.data.response.success_msg);
          }
          if (response.data.response?.warning_msg)
            toast.warning('We have some warnings, please check Data log.')
        } else {
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const uploadSalesForecastFileApi = (file, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post(
    'zip-file-upload',
    file,
    {
      params: data,
      headers: headers
    },
  );
  // result = axios.post(
  //   'sales-forecast-upload?delete_from=' + startDate + '&delete_to=' + endDate + '&functionality=' + type,
  //   file,
  //   { headers: headers },
  // );
  return result;
};

//sales forecast batch job

export const uploadSalesForecastBatchJob = (
  file,
  startDate,
  endDate,
  jobName,
) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadSalesForecastBatchJobApi(file, startDate, endDate, jobName)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchEnd());
          toast.success(response.data.response);
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadSalesForecastBatchJobApi = (file, startDate, endDate, jobName) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post(
    'batch-job?app_type=Promotion Planning&job_type=Promotion Sales-Forecast File Upload&job_name=' +
    jobName +
    '&delete_from=' +
    startDate +
    '&delete_to=' +
    endDate,
    file,
    { headers: headers },
  );
  return result;
};

// ============================================
// New Forecast API Actions
// ============================================

// GET /forecasts - Get all forecasts
export const getForecasts = () => {
  return (dispatch) => {
    dispatch({ type: GET_FORECASTS_START });
    getForecastsAPI()
      .then((response) => {
        console.log('getForecasts action - raw response:', response);
        console.log('getForecasts action - response.data:', response.data);

        // Handle different response structures
        let data = response.data;

        // If response.data is already an array, use it directly
        if (Array.isArray(data)) {
          console.log('getForecasts action - using direct array:', data);
          dispatch({
            type: GET_FORECASTS_SUCCESS,
            data: data,
          });
          return;
        }

        // Check if data is wrapped in response object
        if (data && data.response && Array.isArray(data.response)) {
          data = data.response;
        } else if (data && data.data && Array.isArray(data.data)) {
          data = data.data;
        }

        // Ensure we always dispatch an array
        const forecastData = Array.isArray(data) ? data : [];
        console.log('getForecasts action - dispatching:', forecastData);
        dispatch({
          type: GET_FORECASTS_SUCCESS,
          data: forecastData,
        });
      })
      .catch((error) => {
        console.error('getForecasts action - error:', error);
        dispatch({ type: GET_FORECASTS_FAIL, error });
      });
  };
};

const getForecastsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get('/forecasts', { headers });
};

// GET /forecasts/:id - Get single forecast
export const getForecastById = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_FORECAST_BY_ID_START });
    getForecastByIdAPI(id)
      .then((response) => {
        console.log('getForecastById raw response:', response);
        console.log('getForecastById response.data:', response.data);

        // Handle different response structures
        let data = response.data;

        // Check if data is wrapped in response object
        if (data && data.response && !Array.isArray(data.response)) {
          data = data.response;
        } else if (data && data.data && !Array.isArray(data.data)) {
          data = data.data;
        }

        console.log('getForecastById processed data:', data);

        dispatch({
          type: GET_FORECAST_BY_ID_SUCCESS,
          data: data,
        });
      })
      .catch((error) => {
        console.error('getForecastById error:', error);
        console.error('getForecastById error response:', error.response);
        dispatch({ type: GET_FORECAST_BY_ID_FAIL, error });
      });
  };
};

const getForecastByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`/forecasts/${id}`, { headers });
};

// POST /forecasts - Create forecast
export const createForecast = (data) => {
  return (dispatch) => {
    dispatch({ type: CREATE_FORECAST_START });
    createForecastAPI(data)
      .then((response) => {
        dispatch({ type: CREATE_FORECAST_SUCCESS, data: response.data });
        toast.success('Forecast created successfully');
      })
      .catch((error) => {
        dispatch({ type: CREATE_FORECAST_FAIL, error });
      });
  };
};

const createForecastAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('/forecasts', data, { headers });
};

// PUT /forecasts/:id - Update forecast
export const updateForecast = (id, data) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_FORECAST_START });
    updateForecastAPI(id, data)
      .then((response) => {
        dispatch({ type: UPDATE_FORECAST_SUCCESS, data: response.data });
        toast.success('Forecast updated successfully');
      })
      .catch((error) => {
        dispatch({ type: UPDATE_FORECAST_FAIL, error });
      });
  };
};

const updateForecastAPI = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.put(`/forecasts/${id}`, data, { headers });
};

// DELETE /forecasts/:id - Delete forecast
export const deleteForecast = (id) => {
  return (dispatch) => {
    dispatch({ type: DELETE_FORECAST_START });
    deleteForecastAPI(id)
      .then(() => {
        dispatch({ type: DELETE_FORECAST_SUCCESS });
        toast.success('Forecast deleted successfully');
      })
      .catch((error) => {
        dispatch({ type: DELETE_FORECAST_FAIL, error });
      });
  };
};

const deleteForecastAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.delete(`/forecasts/${id}`, { headers });
};

// GET /forecasts/:id/data - Get forecast data
export const getForecastData = (forecastTypeId, year, versionName) => {
  return (dispatch) => {
    dispatch({ type: GET_FORECAST_DATA_START });
    const params = { year, version: versionName };
    getForecastDataAPI(forecastTypeId, params)
      .then((response) => {
        dispatch({
          type: GET_FORECAST_DATA_SUCCESS,
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: GET_FORECAST_DATA_FAIL, error });
      });
  };
};

const getForecastDataAPI = (forecastTypeId, params) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get(`/forecasts/${forecastTypeId}/data`, {
    headers,
    params,
  });
};

// POST /forecasts/:id/data - Save forecast data
export const saveForecastData = (forecastTypeId, year, data, versionName) => {
  return (dispatch) => {
    dispatch({ type: SAVE_FORECAST_DATA_START });
    saveForecastDataAPI(forecastTypeId, {
      forecast_type_id: forecastTypeId,
      year,
      data,
      version_name: versionName,
    })
      .then(() => {
        dispatch({ type: SAVE_FORECAST_DATA_SUCCESS });
        toast.success('Forecast data saved successfully');
      })
      .catch((error) => {
        dispatch({ type: SAVE_FORECAST_DATA_FAIL, error });
      });
  };
};

const saveForecastDataAPI = (forecastTypeId, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post(`/forecasts/${forecastTypeId}/data`, data, { headers });
};

// POST /forecasts/:id/execute-query/:queryNumber - Execute query
export const executeQuery = (forecastTypeId, queryNumber) => {
  return (dispatch) => {
    dispatch({ type: EXECUTE_QUERY_START });
    executeQueryAPI(forecastTypeId, queryNumber)
      .then((response) => {
        dispatch({
          type: EXECUTE_QUERY_SUCCESS,
          data: response.data,
        });
        toast.success('Query executed successfully');
      })
      .catch((error) => {
        dispatch({ type: EXECUTE_QUERY_FAIL, error });
      });
  };
};

const executeQueryAPI = (forecastTypeId, queryNumber) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post(
    `/forecasts/${forecastTypeId}/execute-query/${queryNumber}`,
    {},
    { headers },
  );
};

// POST /forecasts/:id/upload - Upload forecast data
export const uploadForecastData = (forecastTypeId, file) => {
  return (dispatch) => {
    dispatch({ type: UPLOAD_FORECAST_DATA_START });
    const formData = new FormData();
    formData.append('file', file);
    uploadForecastDataAPI(forecastTypeId, formData)
      .then(() => {
        dispatch({ type: UPLOAD_FORECAST_DATA_SUCCESS });
        toast.success('File uploaded successfully');
      })
      .catch((error) => {
        dispatch({ type: UPLOAD_FORECAST_DATA_FAIL, error });
      });
  };
};

const uploadForecastDataAPI = (forecastTypeId, formData) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data',
  };
  return axios.post(`/forecasts/${forecastTypeId}/upload`, formData, {
    headers,
  });
};

// POST /forecasts/:id/copy-data - Copy forecast data
export const copyForecastData = (
  forecastTypeId,
  sourceYear,
  sourceVersionName,
  targetYear,
  targetVersionName,
) => {
  return (dispatch) => {
    dispatch({ type: COPY_FORECAST_DATA_START });
    copyForecastDataAPI(forecastTypeId, {
      forecast_type_id: forecastTypeId,
      source_year: sourceYear,
      source_version_name: sourceVersionName,
      target_year: targetYear,
      target_version_name: targetVersionName,
    })
      .then(() => {
        dispatch({ type: COPY_FORECAST_DATA_SUCCESS });
        toast.success('Forecast data copied successfully');
      })
      .catch((error) => {
        dispatch({ type: COPY_FORECAST_DATA_FAIL, error });
      });
  };
};

const copyForecastDataAPI = (forecastTypeId, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post(`/forecasts/${forecastTypeId}/copy-data`, data, {
    headers,
  });
};

// ============================================
// External API Actions
// ============================================

const EXTERNAL_API_BASE_URL = process.env.REACT_APP_EXTERNAL_API_URL || 'http://localhost:8081/api/external';

// Create a separate axios instance for external API calls (direct calls, not through main API)
const externalAxios = axios.create({
  baseURL: EXTERNAL_API_BASE_URL,
});

// Add request interceptor to include auth token if available
externalAxios.interceptors.request.use(
  (config) => {
    const token = secureLocalStorage.getItem('aTk');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// POST /external/login - Login to external API
export const externalLogin = (email, password) => {
  return (dispatch) => {
    dispatch({ type: EXTERNAL_LOGIN_START });
    dispatch(fetchStart());
    externalLoginAPI(email, password)
      .then((response) => {
        dispatch({ type: EXTERNAL_LOGIN_SUCCESS, data: response.data });
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch({ type: EXTERNAL_LOGIN_FAIL, error });
        dispatch(fetchEnd());
        toast.error('External API login failed');
        throw error;
      });
  };
};

const externalLoginAPI = (email, password) => {
  return externalAxios.post('/login', { email, password });
};

// GET /external/attributes - Get attributes from external API
export const getExternalAttributes = (page = 1, limit = 1000, withValues = true) => {
  return (dispatch) => {
    dispatch({ type: GET_EXTERNAL_ATTRIBUTES_START });
    dispatch(fetchStart());
    getExternalAttributesAPI(page, limit, withValues)
      .then((response) => {
        let data = [];
        if (response.data.response && response.data.response.records && Array.isArray(response.data.response.records)) {
          data = response.data.response.records;
        } else if (response.data.response && Array.isArray(response.data.response)) {
          data = response.data.response;
        } else if (response.data.data && Array.isArray(response.data.data)) {
          data = response.data.data;
        } else if (Array.isArray(response.data)) {
          data = response.data;
        }
        dispatch({ type: GET_EXTERNAL_ATTRIBUTES_SUCCESS, data });
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch({ type: GET_EXTERNAL_ATTRIBUTES_FAIL, error });
        dispatch(fetchEnd());
        toast.error('Failed to load attributes');
        throw error;
      });
  };
};

const getExternalAttributesAPI = (page, limit, withValues) => {
  return externalAxios.get('/attributes', {
    params: { page, limit, with_values: withValues },
  });
};

// POST /external/queries - Get queries from external API
export const getExternalQueries = (attributeName = 'predefined_query', applicationType = 'Designer Studio') => {
  return (dispatch) => {
    dispatch({ type: GET_EXTERNAL_QUERIES_START });
    dispatch(fetchStart());
    getExternalQueriesAPI(attributeName, applicationType)
      .then((response) => {
        let data = [];
        if (response.data.response && Array.isArray(response.data.response)) {
          data = response.data.response;
        } else if (response.data.data && Array.isArray(response.data.data)) {
          data = response.data.data;
        } else if (Array.isArray(response.data)) {
          data = response.data;
        }
        dispatch({ type: GET_EXTERNAL_QUERIES_SUCCESS, data });
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch({ type: GET_EXTERNAL_QUERIES_FAIL, error });
        dispatch(fetchEnd());
        toast.error('Failed to load queries');
        throw error;
      });
  };
};

const getExternalQueriesAPI = (attributeName, applicationType) => {
  return externalAxios.post('/queries', {
    attribute_name: attributeName,
    application_type: applicationType,
  });
};

// GET /attribute-labels - Get attribute labels (main API, not external)
export const getForecastAttributeLabels = () => {
  return (dispatch) => {
    dispatch({ type: GET_FORECAST_ATTRIBUTE_LABELS_START });
    dispatch(fetchStart());
    getForecastAttributeLabelsAPI()
      .then((response) => {
        let data = [];
        if (response.data.response && response.data.response.records && Array.isArray(response.data.response.records)) {
          data = response.data.response.records;
        } else if (response.data.response && Array.isArray(response.data.response)) {
          data = response.data.response;
        } else if (response.data.data && Array.isArray(response.data.data)) {
          data = response.data.data;
        } else if (Array.isArray(response.data)) {
          data = response.data;
        }
        dispatch({ type: GET_FORECAST_ATTRIBUTE_LABELS_SUCCESS, data });
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch({ type: GET_FORECAST_ATTRIBUTE_LABELS_FAIL, error });
        dispatch(fetchEnd());
        toast.error('Failed to load attribute labels');
        throw error;
      });
  };
};

const getForecastAttributeLabelsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get('/attribute-labels', { headers });
};

// GET /external/run-sql-work-bench/:queryNumber - Execute SQL workbench query
export const runSQLWorkbench = (queryNumber) => {
  return (dispatch) => {
    dispatch({ type: RUN_SQL_WORKBENCH_START });
    dispatch(fetchStart());
    runSQLWorkbenchAPI(queryNumber)
      .then((response) => {
        let data = response.data;
        if (response.data.response && Array.isArray(response.data.response)) {
          data = response.data.response;
        } else if (response.data.data && Array.isArray(response.data.data)) {
          data = response.data.data;
        } else if (Array.isArray(response.data)) {
          data = response.data;
        }
        dispatch({ type: RUN_SQL_WORKBENCH_SUCCESS, data });
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch({ type: RUN_SQL_WORKBENCH_FAIL, error });
        dispatch(fetchEnd());
        toast.error('Failed to execute SQL workbench query');
        throw error;
      });
  };
};

const runSQLWorkbenchAPI = (queryNumber) => {
  return externalAxios.get(`/run-sql-work-bench/${queryNumber}`);
};
